import { Button, Col, Form, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import Select from "react-select"

export default function FarmForm({state, handleInputChange, submit, isAddingOrEditing, isRegistering, breederOptions = [], technicianOptions = []}) {
	const { t } = useTranslation()

	const breeders = breederOptions?.map(breeder => ({
		value: breeder._id,
		label: breeder.name
	}));

	const technicians = technicianOptions?.map(technician => ({
		value: technician._id,
		label: technician.name
	}));

	return (
		<Form onSubmit={submit} className="px-4 formulario">
			<Row className="my-2">
				<Col xs={12} md={6}>
					<Form.Group className="mb-3">
						<Form.Label>{t('admin.farm.name')}</Form.Label>
						<Form.Control
							type="text"
							name="name"
							value={state.name || ''}
							onChange={handleInputChange}
							required
						/>
					</Form.Group>
				</Col>
				<Col xs={12} md={6}>
					<Form.Group className="mb-3">
						<Form.Label>{t('admin.farm.regaCode')}</Form.Label>
						<Form.Control
							type="text"
							name="regaCode"
							value={state.regaCode || ''}
							onChange={handleInputChange}
						/>
					</Form.Group>
				</Col>
			</Row>
			<Row className="my-2">
				<Col xs={12} md={6}>
					<Form.Group className="mb-3">
						<Form.Label>{t('admin.farm.sigCoordinates')}</Form.Label>
						<Form.Control
							type="text"
							name="sigCoordinates"
							value={state.sigCoordinates || ''}
							onChange={handleInputChange}
						/>
					</Form.Group>
				</Col>
				<Col xs={12} md={6}>
					<Form.Group className="mb-3">
						<Form.Label>{t('admin.farm.breeder')}</Form.Label>
						<Select
							options={breeders}
							value={state.breeder ? breeders?.find(option => option.value === state.breeder?._id) : null}
							onChange={option => handleInputChange({ target: { name: 'breeder', value: option.value } })}
						/>
					</Form.Group>
				</Col>
			</Row>
			<Row className="my-2">
				<Col xs={12} md={6}>
					<Form.Group className="mb-3">
						<Form.Label>{t('admin.farm.technicians')}</Form.Label>
						<Select
							options={technicians}
							value={state.technicians ? state.technicians.map(techId => technicians?.find(option => option.value === techId)) : []}
							onChange={selectedOptions => handleInputChange({
								target: {
								name: 'technicians',
								value: selectedOptions.map(option => option.value)
								}
							})}
							isMulti
						  	isClearable
						/>
					</Form.Group>
				</Col>
			</Row>
			<Row>
				<Col xs={12} lg={6} className="my-2 ms-auto">
					<Button variant='primary' type="submit" className="w-100 my-2">
					{isRegistering ?
						<>
							<span className="spinner-border spinner-border-sm align-middle ms-2"></span>
						</>
					:
						isAddingOrEditing === 'editing' ?
							<>{t('admin.farm.edit')}</>
						:
							<>{t('admin.farm.register')}</>
					}
					</Button>
				</Col>
			</Row>
		</Form>
	)
}
